<template>
<div class="row mt-5 justify-content-between">
  <div class="col-sm-3" v-if="checkForPermission(add_sales_profile_visit_permission)">
    <h4 class="card-title mb-3">Enter Last Visit</h4>
    <form @submit.prevent="addNewVisit">
      <div class="row">
        <div class="col-12 mt-3">
          <label>Sales Type</label>
          <multiselect v-model="last_visit" :options="salesTypeList.objects" placeholder="Select one" label="name" track-by="name"
                       :class="{'is-invalid': v$.last_visit.$error}">
          </multiselect>
          <p
              v-for="error of v$.last_visit.$errors"
              :key="error.$uid"
              class="invalid-feedback"
          >
            {{error.$message}}
          </p>
        </div>
        <div v-for="(error, index) in customerErrors" :key="index" style="color: #D13704;">
          {{error.message}}
        </div>
        <div class="mt-3 col-12">
          <b-button variant="info" size="lg" class="py-2 text-white w-100" disabled v-if="customerLoading">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Loading
          </b-button>
          <b-button variant="info" size="lg" class="py-2 text-white w-100 text-white" type="submit" v-else>
            Add Visit
          </b-button>
        </div>
      </div>
    </form>
  </div>
  <div class="col-sm-7">
    <data-table :columns="columns" :rows="visits"/>
  </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DataTable from "@/components/data-table";
import {ALL_SALES_VISIT_TYPES} from "@/gql/customers";
import {required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {mapActions, mapGetters} from "vuex";
import {successToast} from "@/components/successToast";
import {permissions} from "@/router/permissions";

export default {
  name: "visits",
  components: {
    DataTable,
    Multiselect
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      last_visit: "",
      add_sales_profile_visit_permission: permissions.add_sales_profile_visit_permission,
      columns:[
        {
          field: 'visitDate',
          label: 'Visit Date'
        },
        {
          field: 'salesType',
          label: 'Type'
        },
        {
          field: 'staff',
          label: 'Staff'
        },
        {
          field: 'createdAt',
          label: 'Added On'
        }
      ],
      salesTypeList: {
        objects: []
      }
    }
  },
  props: {
    visits : {
      type: Array,
    }
  },
  validations () {
    return {
      last_visit: {required},
    }
  },
  computed: {
    ... mapGetters({
      customerLoading: 'customers/customerLoading',
      customerErrors: 'customers/customerErrors'
    }),
  },
  apollo: {
    salesTypeList: {
      query: ALL_SALES_VISIT_TYPES,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    }
  },
  methods: {
    ... mapActions({
      addNewVisitFn: 'customers/addNewSalesProfileVisit',
    }),
    async addNewVisit() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        feedback: this.$route.params.id,
        salesType: this.last_visit.publicId,
      }
      await this.addNewVisitFn(data).then(resp => {
        this.$emit('updateProfile')
        if(resp.publicId){
          successToast(`New Visit added successfully`)
        }
      })

      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
